import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function unassignEnrollmentFromCenterGroup(input: {
  centerId: number
  groupId: number
  enrollmentCenterId: number
}) {
  const { centerId, groupId, enrollmentCenterId } = input
  return restApiClient
    .url(
      constructApiUrl(API.centers.unassignEnrollmentFromCenterGroup.url, {
        id: centerId,
        groupId,
        enrollmentCenterId
      })
    )
    .delete()
}
